import axiosInstance from "@/axios";

const axios = axiosInstance();

export const state = {
    currentUser: JSON.parse(localStorage.getItem("user")) || null,
    authError: null,
    pending2FAEmail: null,
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('user', newValue)
        localStorage.setItem("user", JSON.stringify(newValue));
    },
    SET_AUTH_MSG(state, authError) {
        state.authError = authError
    },
    SET_PENDING_EMAIL(state, email) {
        state.pending2FAEmail = email
    },
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser
    },
    authError: state => state.authError,
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    async logIn({ commit }, { email, password } = {}) {
        try {
            const result = await axios.post("/agent/login", {
                email,
                password,
            });

            commit('SET_PENDING_EMAIL', result.data.email);
            commit("SET_AUTH_MSG", null);
            return { requires2FA: true };
        } catch (error) {
            commit("SET_AUTH_MSG", error.response.data.message);
            throw error;
        }
    },

    async verify2FA({ commit }, { email, code } = {}) {
        try {
            const result = await axios.post("/agent/verify-2fa", {
                email,
                code,
            });

            commit('SET_CURRENT_USER', result.data.user);
            localStorage.setItem('token', result.data.token);
            commit('SET_PENDING_EMAIL', null);
            commit("SET_AUTH_MSG", null);
        } catch (error) {
            commit("SET_AUTH_MSG", error.response.data.message);
            throw error;
        }
    },


    async logOut({ commit }) {
        try {
            // Try to call logout endpoint if token exists
            const token = localStorage.getItem('token');
            if (token) {
                await axiosInstance({ requiresAuth: true }).post("/agent/logout");
            }
        } catch (error) {
            // If logout fails, we still want to clear local data
            // Silently continue with cleanup
        } finally {
            // Always clear local authentication data
            commit('SET_CURRENT_USER', null);
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            sessionStorage.clear();
        }
    },

    // Force logout without API call (for when token is already invalid)
    forceLogOut({ commit }) {
        commit('SET_CURRENT_USER', null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        sessionStorage.clear();
    },

    register({ commit, dispatch, getters }, { username, email, password, confirm_password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return axiosInstance().post('/agent/register', { username, email, password, confirm_password }).then((response) => {
            const user = response.data && response.data.user ? response.data.user : null;
            if (user) commit('SET_CURRENT_USER', user);
            if (response.data && response.data.token) {
                localStorage.setItem('token', response.data.token);
            }
            return user;
        });
    },

    resetPassword({ dispatch, getters }, { email } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return axiosInstance().post('/agent/forgot-password', { email }).then((response) => {
            return response.data;
        });
    },

    validate({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null)

        const token = localStorage.getItem('token');
        if (!token) {
            commit('SET_CURRENT_USER', null);
            return Promise.resolve(null);
        }

        return Promise.resolve(state.currentUser);
    },
}


function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
